import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatBadgeModule } from '@angular/material/badge';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ListadoDescargasComponent } from './listado-descargas/listado-descargas.component';
import { DescargasComponent } from './descargas/descargas.component';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';

@NgModule({
  declarations: [ListadoDescargasComponent, DescargasComponent],
  imports: [
    AuxiliaresModule,
    CommonModule,
    MatMenuModule,
    MatPaginatorModule,
    MatBadgeModule,
    MatProgressSpinnerModule,
  ],
  exports: [DescargasComponent],
})
export class DescargasModule {}
